export * from './lib/interface/attachments/attachments-response.interface';
export * from './lib/interface/attachments/modify-attachments.interface';
export * from './lib/interface/auth/signin.interface';
export * from './lib/interface/auth/signup.interface';
export * from './lib/interface/clients/clients-response.interface';
export * from './lib/interface/clients/modify-clients.interface';
export * from './lib/interface/companies/company-response.interface';
export * from './lib/interface/companies/modify-company.interface';
export * from './lib/interface/financials/financials-response.interface';
export * from './lib/interface/financials/modify-financials.interface';
export * from './lib/interface/leads/leads-response.interface';
export * from './lib/interface/leads/modify-leads.interface';
export * from './lib/interface/proposals/proposals-response.interface';
export * from './lib/interface/proposals/modify-proposals.interface';
export * from './lib/interface/sales/sales-response.interface';
export * from './lib/interface/sales/modify-sales.interface';
export * from './lib/interface/users/users-response.interface';
export * from './lib/interface/users/modify-users.interface';
export * from './lib/interface/monitorings/monitorings-response.interface';
export * from './lib/interface/monitorings/modify-monitorings.interface';
export * from './lib/interface/api-response/api-response.interface';